module.exports = __webpack_public_path__ + "graphics/checkout-live-chat-icon.ckh.7b77ac1a86ce4146adb3d6a3e17f4d59.svg";